/**
 * §MobileQA: uploads are stored under a `<uuid>-<original name>` storage key, and workflow-manager
 * serves that whole key as `fileName`. Rendered raw it reads as
 *
 *   e6f11ec7-7a3c-4de5-a9b8-f6f2da8ba274-i-Score Report - PRIMARY - 2026-08-02.pdf
 *
 * which is bad everywhere but actively useless in the banner: that line is `noWrap`, so the 36
 * characters of key are all the agent ever sees and the real name is truncated away entirely.
 *
 * The prefix is only stripped when the leading segment is a well-formed UUID followed by "-", so a
 * document genuinely named "2026-08-02 report.pdf" is left alone.
 */
const STORAGE_KEY_PREFIX =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}-/i;

export const displayFileName = (name: string): string =>
  typeof name === "string" ? name.replace(STORAGE_KEY_PREFIX, "") : name;
